import { Tooltip } from '@mui/material';
import Box from '@mui/material/Box';
import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';
import React from 'react';
import isMac from 'utils/isMac';

const styles = {
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    color: '#fff',
    gap: 3,
  },
  title: {
    fontWeight: 600,
  },
  shortcuts: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.5,
  },
  shortcut: {
    display: 'inline-block',
    padding: '2px 4px',
    borderRadius: 1,
    backgroundColor: '#3C4E71',
    minWidth: '24px',
    textAlign: 'center',
    py: 0.5,
    px: 0.75,
  },
};

const tooltipSlotProps = {
  tooltip: {
    sx: {
      backgroundColor: '#27344E',
      color: '#fff',
      fontSize: 12,
      fontWeight: 500,
      borderRadius: '8px',
      padding: '8px 12px',
    },
  },
  arrow: {
    sx: {
      color: '#27344E',
    },
  },
};

const ShortcutTooltip = ({
  title,
  shortcut,
  placement = 'bottom',
  arrow = true,
  children,
  ...rest
}) => {
  const shortcuts = isArray(shortcut) ? shortcut : [shortcut];
  return (
    <Tooltip
      slotProps={tooltipSlotProps}
      title={
        <Box sx={styles.wrapper}>
          <Box sx={styles.title}>{title}</Box>
          <Box sx={styles.shortcuts}>
            {shortcuts.map(s => (
              <Box key={s} sx={styles.shortcut}>
                {isMac ? s.replace(/Ctrl/i, '⌘') : s}
              </Box>
            ))}
          </Box>
        </Box>
      }
      placement={placement}
      arrow={arrow}
      {...rest}
    >
      {children}
    </Tooltip>
  );
};

ShortcutTooltip.propTypes = {
  title: PropTypes.string.isRequired,
  shortcut: PropTypes.string.isRequired,
  placement: PropTypes.oneOf(['top', 'bottom', 'left', 'right']),
  arrow: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default ShortcutTooltip;
